import styles from './ExpiredApplication.module.css';

const ExpiredApplication = () => {
    return (
        <div className={styles.expiredContainer}>
            <h2>This paylink has now expired</h2>
            <p>
                Your pay link’s expired after 7 days of inactivity. It’s easy to
                refresh it - just contact us and we’ll sort it.
            </p>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default ExpiredApplication;
